<template>
	<v-dialog v-model="showDialog" max-width="600" persistent>
		<v-card>
			<v-card-title> Add Activity Computed Field </v-card-title>
			<v-card-text>
				<v-text-field label="Name" v-model="computedField.Name" />
				<v-select
					v-model="computedField.AgregateFunction"
					:items="agregateFunctionsItems"
					label="Agregate Function"
					item-text="text"
					item-value="value"
				>
				</v-select>
				<v-select
					v-model="computedField.GridViewFieldId"
					:disabled="hasAgregateFunction"
					:items="fields"
					label="Field"
					item-text="Label"
					item-value="Id"
				>
				</v-select>
				<v-btn-toggle
					v-model="computedField.FilterOperator"
					tile
					color="primary"
					class="d-flex"
					group
					mandatory
				>
					<span class="align-self-center">Operation:</span>
					<v-btn class="flex-grow-1" :value="1">And</v-btn>
					<v-btn class="flex-grow-1" :value="2">Or</v-btn>
				</v-btn-toggle>
				<v-card-text>
					<v-form ref="form">
						<div
							v-for="(filter, index) in localFilter"
							:key="index"
							class="d-flex mb-4"
						>
							<filter-component
								v-if="filter"
								:columns="fields"
								:filter="filter"
								:index="index"
								@onRemoveFilter="removeFilter"
								@filterChanged="onFilterChanged"
							/>
						</div>
					</v-form>
					<v-btn color="primary" outlined @click="addFilter">
						<v-icon>mdi-plus</v-icon>
						Add filter
					</v-btn>
				</v-card-text>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-spacer />
				<v-btn color="primary" @click.stop="onSave">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ActivityComputedFieldsActions } from '../../../../store/actions';
import { ActivityComputedFieldsGetters } from '../../../../store/getters';
import { mapGetters } from 'vuex';
import FilterComponent from '../../../shared/gridViews/FilterComponent.vue';
import { agregateFunctions } from '../../../../enums/agregateFunctions';
import { FieldDataTypes } from '../../../../enums/fieldDataTypes';
export default {
	name: 'ActivityComputedFieldModal',
	props: {
		showDialog: Boolean,
		computedField: Object,
	},
	components: { FilterComponent },
	data() {
		return {
			localFilter: [],
			filteredFields: [],
			agregateFunctionsItems: [
				{ value: agregateFunctions.COUNT, text: 'COUNT' },
				{ value: agregateFunctions.MAX, text: 'MAX' },
				{ value: agregateFunctions.MIN, text: 'MIN' },
				{ value: agregateFunctions.SUM, text: 'SUM' },
			],
		};
	},
	computed: {
		...mapGetters({
			fields: [ActivityComputedFieldsGetters.GRID_VIEW_FIELDS],
			selectedComputedField: [
				ActivityComputedFieldsGetters.SELECTED_COPMUTED_FIELD,
			],
		}),
		hasAgregateFunction() {
			if (!this.computedField.AgregateFunction) return true;
			return false;
		},
	},
	watch: {
		computedField(newVal) {
			if (newVal.Id) {
				this.localFilter = newVal.Filters;
			}
		},
		'computedField.AgregateFunction'(newVal) {
			switch (newVal) {
				case agregateFunctions.MAX:
				case agregateFunctions.MIN:
				case agregateFunctions.SUM:
					this.filteredFields = this.fields.filter(
						(x) =>
							x.DataField.DataType == FieldDataTypes.AMOUNT ||
							x.DataField.DataType == FieldDataTypes.NUMBER
					);
					break;
				case agregateFunctions.COUNT:
					this.filteredFields = this.fields;
					break;
				default:
					break;
			}
		},
	},
	mounted() {
		this.loadFields();
	},
	methods: {
		loadFields() {
			this.$store.dispatch(
				ActivityComputedFieldsActions.LOAD_GRID_VIEW_FIELDS,
				this.$route.params.id
			);
		},
		addFilter() {
			this.localFilter.push({
				FieldId: '',
				Operator: null,
				Value: '',
			});
		},
		onClose() {
			this.localFilter = [];
			this.$emit('close');
		},
		onSave() {
			this.computedField.ActivityComputedFieldFilters = this.localFilter;
			this.computedField.ActivityId = this.$route.params.id;
			if (this.computedField.Id) {
				this.$store
					.dispatch(
						ActivityComputedFieldsActions.UPDATE_COMPUTED_FIELD,
						this.computedField
					)
					.then((success) => {
						if (success) this.onClose();
					});
			} else {
				this.$store
					.dispatch(
						ActivityComputedFieldsActions.INSERT_COMPUTED_FIELD,
						this.computedField
					)
					.then((success) => {
						if (success) this.onClose();
					});
			}
		},
		removeFilter(index) {
			this.localFilter.splice(index, 1);
		},
		onFilterChanged(filter, index) {
			let obj = {
				GridViewFieldId: filter.FieldId,
				Operator: filter.Operator,
				Value: filter.Value,
			};
			this.localFilter.splice(index, 1, obj);
		},
	},
};
</script>
